<template>
  <div class="columns my-0 is-multiline" >
    <div class="column is-3">
      <kst-input floating-label load-on-focus
        field="Search" :data="searchData" :catalog="ExpSearchCatalog"
        @input="handleInput"
      />
    </div>
    <div class="column is-3">
      <kst-input floating-label
        field="SubCategoryID" :data="searchData" :catalog="ExpSearchCatalog"
        :options="subCategoryOptions" @input="handleInput"
      />
    </div>
    <div class="column is-narrow">
      <kst-input floating-label
        field="WarehouseID" :data="searchData" :catalog="ExpSearchCatalog"
        :options="warehouseOptions" @input="handleInput"
      />
    </div>
    <div class="column is-narrow">
      <kst-input floating-label
        field="PaymentTypeName" :data="searchData" :catalog="ExpSearchCatalog"
        :options="paymentTypeOptions" @input="handleInput"
      />
    </div>
    <div class="column is-narrow">
      <kst-input floating-label
        field="Date" :data="searchData" :catalog="ExpSearchCatalog"
        @input="handleInput"
      />
    </div>
  </div>
</template>

<script>
import ExpSearchCatalog from "../ExpSearchCatalog.js";

export default {
  props: {
    searchData: Object,
    paymentTypeOptions: Object,
    subCategoryOptions: Object,
    warehouseOptions: Object
  },
  data: () => ({
    ExpSearchCatalog: ExpSearchCatalog
  }),
  methods: {
    handleInput() {
      this.$emit(this.$kst.Enum.Event.Input);
    }
  }
}
</script>